import { render, staticRenderFns } from "./buyCar.vue?vue&type=template&id=38cff85b&scoped=true&"
import script from "./buyCar.vue?vue&type=script&lang=js&"
export * from "./buyCar.vue?vue&type=script&lang=js&"
import style0 from "./buyCar.vue?vue&type=style&index=0&id=38cff85b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cff85b",
  null
  
)

export default component.exports